<template>
  <div class="company-audit-main">
    <card>
    <form-table-page
      class="index-all-box"
      :data="formData"
      :label="formLabel"
      @Query="Query"
      @Reset="Reset"
    >
      <template slot="companyName">
        <el-input
          v-model="formData.companyName"
          style="width:100%"
          :placeholder="$t('queryForm.pleaseEnter')"
        />
      </template>
      <template slot="projectName">
        <el-input
          v-model="formData.projectName"
          style="width:100%"
          :placeholder="$t('queryForm.pleaseEnter')"
        />
      </template>
      <template slot="processName">
        <el-input
          v-model="formData.processName"
          style="width:100%"
          :placeholder="$t('queryForm.pleaseEnter')"
        />
      </template>
      <template slot="technicalArea">
        <el-select
          v-model="formData.technicalArea"
          style="width:100%"
          :placeholder="$t('queryForm.pleaseSelect')"
          clearable
        >
          <el-option
            v-for="(item,i) in technicalAreaList"
            :key="i"
            :value="item.key"
            :label="item.value"
          />
        </el-select>
      </template>
      <template slot="status">
        <el-select
          v-model="formData.status"
          style="width:100%"
          :placeholder="$t('queryForm.pleaseSelect')"
          clearable
        >
          <el-option :value="1" :label="$t('queryForm.pendingForApproval')" />
          <el-option :value="2" :label="$t('queryForm.approved')" />
          <el-option :value="3" :label="$t('queryForm.rejected')" />
          <!-- <el-option :value="4" :label="$t('queryForm.draft')" /> -->
        </el-select>
      </template>
      <template slot="startTime">
        <el-date-picker
          v-model="formData.startTime"
          type="date"
          style="width:100%"
          :editable="false"
          :placeholder="$t('queryForm.pleaseSelect')"
          value-format="yyyy-MM-dd"
          clearable
        />
      </template>
      <template slot="endTime">
        <el-date-picker
          v-model="formData.endTime"
          type="date"
          style="width:100%"
          :editable="false"
          :placeholder="$t('queryForm.pleaseSelect')"
          value-format="yyyy-MM-dd"
          clearable
        />
      </template>
    </form-table-page>
    </card>

    <card style="margin-top: 10px;">
    <div class="content-list-box">
      <div v-if="!processList || processList.length == 0" class="content-NoData">
        {{ $t("messageCommon.noData") }}
      </div>
      <div v-for="(item, i) in processList" :key="i" class="content-list">
        <div class="column-dom clearfix">
          <div class="hint-title-name">{{ item.companyName }}&nbsp;/&nbsp;{{ item.projectName }}</div>
          <div class="title-info-box clearfix table-column-action">
            <div class="title">{{ item.processName }}</div>
            <div class="text-btn cell">
              <el-link
                :underline="false"
                v-if="item.status===1&&buttonPerCheck('approve')"
                type="primary"
                @click="openProcessApprovePage(item.id)"
              >{{ $t('formData.approve') }}</el-link>
              <el-link
                :underline="false"
                v-if="buttonPerCheck('view')"
                type="primary"
                @click="openProcessViewPage(item.id)"
              >{{ $t('formData.view') }}</el-link>
            </div>
          </div>

          <div class="block-list-box">
            <div class="block-box">
              <div class="icon">
                <i class="el-icon-first-aid-kit" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.technicalArea') }}</div>
                <div
                  class="info"
                >{{ technicalAreaList.filter(m=>{return m.key===item.technicalArea}).length > 0
                    ? technicalAreaList.filter(m=>{return m.key===item.technicalArea})[0].value : '' }}</div>
              </div>
            </div>

            <div class="block-box">
              <div class="icon">
                <i class="el-icon-ali-status" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.status') }}</div>
                <div class="info">{{ getStatus(item.status) }}</div>
              </div>
            </div>

            <div class="block-box">
              <div class="icon">
                <i class="el-icon-ali-time" />
              </div>
              <div class="block-content">
                <div class="title">{{ $t('formData.createdTime') }}</div>
                <div class="info">{{ item.updateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-page
        ref="pageCom"
        :total="totalPage"
        :currentPage="currentPage"
        :change-fun="pageChange"
      />
    </div>
    </card>
  </div>
</template>

<script>
import { baseEnumsSelectDictionariesType } from "@/api/enumInfo";
import { projectFlowProcess } from "@/api/approvalProcess";
export default {
  components: {},
  props: {},
  data() {
    return {
      formData: {
        companyName: "",
        projectName: "",
        processName: "",
        technicalArea: "",
        status: 1,
        startTime: "",
        endTime: ""
      },
      formLabel: {
        companyName: "queryForm.companyName",
        projectName: "queryForm.projectName",
        processName: "queryForm.processName",
        technicalArea: "queryForm.technicalArea",
        status: "queryForm.status",
        startTime: "queryForm.submitStartDate",
        endTime: "queryForm.submitEndTime"
      },
      processList: [],
      totalPage: 0,
      currentPage: 1,
      technicalAreaList: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    }
  },
  watch: {
    lang() {
      this.getEnumsDictionariesList(1, this.technicalAreaList);
    }
  },
  created() {
    baseEnumsSelectDictionariesType(1).then(res => {
      this.technicalAreaList = res.data;
    });
  },
  mounted() {
    this.getdata.call(
      this,
      this.$refs.pageCom.currentPage,
      this.$refs.pageCom.pageSize
    );
  },
  methods: {
    Query() {
      this.getdata.call(this, 1, this.$refs.pageCom.pageSize);
    },
    Reset() {},
    getStatus(status) {
      switch (status) {
        case 1:
          return this.$t("queryForm.pendingForApproval");
          break;
        case 2:
          return this.$t("queryForm.approved");
          break;
        case 3:
          return this.$t("queryForm.rejected");
          break;
        case 4:
          return this.$t("queryForm.draft");
          break;
        default:
          return "";
          break;
      }
      status;
    },
    pageChange(currentPage, pageSize) {
      this.$refs.pageCom.pageSize = pageSize
      this.getdata.call(this, currentPage, pageSize, this.$refs.pageCom.queryData);
    },
    getdata(currentPage, pageSize, queryData) {
      this.currentPage = currentPage;
      if(!queryData){
        queryData = {...this.formData}
      }
      queryData.pageNum = currentPage
      queryData.pageSize = pageSize
      projectFlowProcess(queryData).then(res => {
        this.processList = res.data.list;
        this.totalPage = res.data.total;
        this.$refs.pageCom.queryData = queryData;
      });
    },

    /**
     * 跳转到查看项目流程页面
     */
    openProcessViewPage(id) {
      this.$router.push({
        name: 'projectProcessAuditView',
        query: {
          id: id,
          backToPage: 'projectProcessAudit'
        }
      })
    },

    /**
     * 跳转到编辑项目流程页面
     */
    openProcessApprovePage(id) {
      this.$router.push({
        name: 'projectProcessDoAudit',
        query: {
          id: id,
          backToPage: 'projectProcessAudit'
        }
      })
    },
  }
};
</script>
<style  scoped>
.content-NoData{
  text-align: center;
  line-height: 60px;
  /* width: 50%; */
  color: #909399;
  font-size: 16px;
}
</style>
